import { Box, Typography, Button } from '@mui/material'
import { Lock, Upgrade } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

interface UpgradeGateProps {
  totalQualifying: number
  visibleQualifying: number
}

const UpgradeGate = ({ totalQualifying, visibleQualifying }: UpgradeGateProps) => {
  const navigate = useNavigate()
  const hidden = totalQualifying - visibleQualifying

  return (
    <Box sx={{
      position: 'relative',
      mt: 2, p: 4,
      textAlign: 'center',
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'action.hover',
    }}>
      <Lock sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
      <Typography variant="h6" gutterBottom>
        {hidden} more finding{hidden !== 1 ? 's' : ''} with recommendations
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Your trial shows {visibleQualifying} of {totalQualifying} findings with actionable recommendations.
        Upgrade to unlock all findings, full recommendations, and detailed reports.
      </Typography>
      <Button
        variant="contained"
        startIcon={<Upgrade />}
        onClick={() => navigate('/pricing')}
        sx={{ px: 4 }}
      >
        View Plans &amp; Upgrade
      </Button>
    </Box>
  )
}

export default UpgradeGate
